module.exports = __webpack_public_path__ + "img/bullhorn.8ec31513.svg";